import { SearchObject } from "app/common/Model/SearchObject";
import { reportServicesPerformed } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";

class HospitalDataStore {
  searchObject = new SearchObject({ formDate: '01/01/2024', toDate: new Date() })
  dataReportServicesPerformed = null;

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearch = (searchObject) => {
    this.searchObject = { ...this.searchObject, ...searchObject };
    this.reportServicesPerformed();
  }

  reportServicesPerformed = async () => {
    let { data } = await reportServicesPerformed(this.searchObject);
    this.dataReportServicesPerformed = data;
  }

  resetStore = () => {
    this.searchObject = new SearchObject({ formDate: '01/01/2024', toDate: new Date() });
    this.dataReportServicesPerformed = null;
  };
}

export default HospitalDataStore;
